import {
	AGENT_ATTRIBUTION_META,
	type AgentAttributionTransactionMeta,
} from '@atlaskit/editor-common/transaction-agent-attribution';
import type { Transaction } from '@atlaskit/editor-prosemirror/state';
import { fg } from '@atlaskit/platform-feature-flags/fg';

import { ACTIONS } from './actions';
import { inEditorDirectStreamingPluginKey } from './in-editor-direct-streaming-plugin-key';

export const initPositions =
	({
		start,
		end,
		showHighlight,
		showAIContentHighlight,
		showTelepointer,
		telepointerPos,
	}: {
		end: number;
		showAIContentHighlight: boolean;
		showHighlight: boolean;
		showTelepointer: boolean;
		start: number;
		telepointerPos: number;
	}) =>
	(tr: Transaction): Transaction => {
		return tr.setMeta(inEditorDirectStreamingPluginKey, {
			action: ACTIONS.INIT_POSITIONS,
			positions: {
				startPos: start,
				userContentEndPos: end,
				telepointerPos,
			},
			showHighlight,
			showAIContentHighlight,
			showTelepointer,
		});
	};

export const adjustInitPositions =
	({ start, end }: { end: number; start: number }) =>
	(tr: Transaction): Transaction => {
		return tr.setMeta(inEditorDirectStreamingPluginKey, {
			action: ACTIONS.ADJUST_INIT_POSITIONS,
			positions: {
				startPos: start,
				userContentEndPos: end,
			},
		});
	};

export const updateStreamPositions =
	({
		aiContentEndPos,
		telepointerPos,
		isFinalStream,
	}: {
		aiContentEndPos: number | undefined;
		isFinalStream: boolean;
		telepointerPos: number | undefined;
	}) =>
	(tr: Transaction): Transaction => {
		return tr.setMeta(inEditorDirectStreamingPluginKey, {
			action: ACTIONS.UPDATE_STREAM_POSITIONS,
			positions: {
				aiContentEndPos,
				telepointerPos,
			},
			isFinalStream,
		});
	};

export const updateLoadingPositions = (tr: Transaction): Transaction => {
	return tr.setMeta(inEditorDirectStreamingPluginKey, {
		action: ACTIONS.UPDATE_LOADING_POSITIONS,
	});
};

export const endStream = (tr: Transaction): Transaction => {
	return tr.setMeta(inEditorDirectStreamingPluginKey, {
		action: ACTIONS.END_STREAM,
	});
};

export const metaTransaction = ({
	tr,
	isFinalStream,
	stackTime,
	agentAttribution,
}: {
	agentAttribution?: AgentAttributionTransactionMeta;
	isFinalStream: boolean;
	stackTime: number | undefined;
	tr: Transaction;
}): Transaction => {
	tr = tr
		.setMeta('isAIStreamingTransformation', true)
		.setMeta('isAIFinalStreamingTransformation', !!isFinalStream)
		.setMeta('scrollIntoView', false);
	if (fg('platform_editor_agentic_step_attribution') && agentAttribution) {
		tr.setMeta(AGENT_ATTRIBUTION_META, agentAttribution);
	}
	if (stackTime) {
		tr.setTime(stackTime);
	}
	return tr;
};
